<template>
  <div>
    <v-row dense>
      <v-col cols="1"><span>{{ this.tag }}</span>
        <span style="float: right; margin-right: 2px;">
          <v-btn fab x-small color="primary" @click="selectAllDays()" v-if="selectAll" style="width: 18px; height: 18px;">
            <v-icon small>mdi-chevron-double-right</v-icon>
          </v-btn>        
        </span>
      </v-col>
      <v-col cols="1" v-for="(day, i) in days" :key="i">
          <v-simple-checkbox dense :color="color" v-model="days[i]" hide-details v-on:input="callChange(i)" style="margin-left: 2px;"></v-simple-checkbox>
      </v-col> 
      <v-col class="mt-1">
        <div v-if="info!==''" :class="`${fontsize}`" v-html="info"></div>
      </v-col>
    </v-row>      
  </div>
</template>

<script>
  export default {
    props: {
      days: Array,
      field: String, 
      tag: String, 
      info: String,
      info_font_size: String,
      color: String,
      selectAll: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
          fontsize: "font-size-" + this.info_font_size,
      }
    },    
    methods:{
      callChange(){        
        this.$emit('updateData', {"field": this.field, "value": this.days});
      },
      selectAllDays() {
        const allTrue = this.days.every(day => day === true);
        const updatedDays = this.days.map(() => !allTrue);
        this.$emit('updateData', {"field": this.field, "value": updatedDays});
      }
    }
  }
</script>

<style scoped>
.font-size-small{
  font-size:small;
}
.font-size-medium{
  font-size:medium;
}
.font-size-large{
  font-size:large;
}
</style>